module.exports = __webpack_public_path__ + "static/media/icon_uncheck-circle.15db284b.svg";